const withInsightBasePath = (path) => `/client/int/${path}`;

export const INSIGHT_GENERAL = withInsightBasePath('general');
export const INSIGHT_GENERAL_OVERVIEW = withInsightBasePath('general/overview');
export const INSIGHT_GENERAL_NODES_MAP = withInsightBasePath('general/nodes-map');
export const INSIGHT_GENERAL_NODES_MAP_MANAGER = withInsightBasePath('general/nodes-map/manager');
export const INSIGHT_GENERAL_NODES_MAP_FARMER = withInsightBasePath('general/nodes-map/farmer');

export const INSIGHT_SERVICE_OVERVIEW = withInsightBasePath('service');
export const INSIGHT_SERVICE_STATUS_APP = withInsightBasePath('service/status-app');
export const INSIGHT_SERVICE_STATUS_MANAGER = withInsightBasePath('service/status-manager');

export const INSIGHT_MANAGER = withInsightBasePath('manager');
export const INSIGHT_MANAGER_TENANTS = withInsightBasePath('manager/tenants');
export const INSIGHT_MANAGER_GATEWAYS = withInsightBasePath('manager/gateways');
export const INSIGHT_MANAGER_SUBSCRIPTIONS = withInsightBasePath('manager/subscriptions');

export const INSIGHT_FARMER_APP = withInsightBasePath('farmer');
export const INSIGHT_FARMER_APP_CUSTOMERS = withInsightBasePath('farmer/customers');
export const INSIGHT_FARMER_APP_DEVICES = withInsightBasePath('farmer/devices');

export const INSIGHT_ANALYTICS = withInsightBasePath('analytics');
export const INSIGHT_EDGE = withInsightBasePath('edge');
export const INSIGHT_QUOTE_TOOL = withInsightBasePath('quote-tool');

export const INSIGHT_ADMINISTRATION = withInsightBasePath('administration');
export const INSIGHT_ADMINISTRATION_USERS = withInsightBasePath('administration/users');
export const INSIGHT_ADMINISTRATION_SERVICES = withInsightBasePath('administration/services');
